module.exports = __webpack_public_path__ + "static/media/marion13.09649ce9.png";